import * as VH from '@radix-ui/react-visually-hidden';

export const VisuallyHidden = (props: {
  children: React.ReactNode;
}) => <VH.Root>{props.children}</VH.Root>;
